import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useContext, useMemo } from 'react';
import { Z3KSettings } from 'z3k-settings/provider/types';
import { HeatingControlType } from 'console/climatic/setting-tabs/type';
import { useConfigurationState } from 'z3k-settings/climatic/configuration/lib/useConfigurationState';
import { CurrentState } from './ui/current-state';
import { CircuitIcon } from './ui/circuit-icon';
import { ExtendedSettings } from './ui/extended-settings';
import { WeatherCard } from './ui/weather-card';
import { TargetTemperatureSettings } from './ui/target-temperature-settings';
import { ScheduleCard } from './ui/schedule-card';
import { PumpSettings } from './ui/pump-settings';
import { ThreewayTapSettings } from './ui/threeway-tap-settings';
import { useHeatingCircuitsItemState } from './lib/useHeatingCircuitsItemState';
import { HeatingCircuit } from 'z3k-config';
import { ColumnBox } from 'console/shared/components/containers';
export const ClimaticHeatingCircuitsItem = memo(function ClimaticHeatingCircuitsItem() {
    const { service_view } = useContext(Z3KSettings);
    const { threeway_tap, circuit } = useHeatingCircuitsItemState();
    const { circuits } = useConfigurationState();
    const circuit_configuration = useMemo(() => circuits.find((circ) => circ.id == circuit.id), [circuits, circuit]);
    const is_show_threeway_tap_settings = service_view &&
        threeway_tap != undefined &&
        circuit_configuration?.control_type !== HeatingControlType.DIRECT;
    return (_jsxs(ColumnBox, { pb: 2, children: [_jsx(CurrentState, {}), _jsx(CircuitIcon, {}), service_view && _jsx(ExtendedSettings, {}), !HeatingCircuit.isDHW(circuit) && _jsx(WeatherCard, {}), _jsx(TargetTemperatureSettings, {}), _jsx(ScheduleCard, {}), service_view && _jsx(PumpSettings, {}), is_show_threeway_tap_settings && _jsx(ThreewayTapSettings, {})] }));
});
